try {
    window.$ = window.jQuery = require('jquery'); //jquery
    require('jquery-ui-dist/jquery-ui.css'); //jquery-ui
    require('jquery-ui-dist/jquery-ui'); //jquery-ui
    require('jquery-datetimepicker'); //jquery datetimepicker
    jQuery.datetimepicker.setLocale('ja');
    require('lazysizes'); // lazysizes
    require('localforage'); // localforage

    /* datatables（ここから） */
    require('datatables.net-bs4');
    // 日本語化
    var language = require('drmonty-datatables-plugins/i18n/Japanese.json');
    window.jQuery(function ($) {
        $.extend(true, $.fn.dataTable.defaults.oLanguage, language);
    });
    // 各種プラグイン
    require('datatables.net-autofill-bs4');
    require('datatables.net-buttons-bs4');
    require('datatables.net-buttons/js/buttons.colVis.js');
    require('datatables.net-buttons/js/buttons.flash.js');
    require('datatables.net-colreorder-bs4');
    require('datatables.net-fixedcolumns-bs4');
    require('datatables.net-fixedheader-bs4');
    require('datatables.net-responsive-bs4');
    require('datatables.net-rowgroup-bs4');
    require('datatables.net-rowreorder-bs4');
    require('datatables.net-select-bs4');
    /* datatables（ここまで） */
} catch (e) { }

require('bootstrap'); //bootstrap